import { TalentMap } from 'web/data/models'
import { TALENT_ID } from '../ids/talent-id'
import { SPEC_ID } from '../ids/spec-ids'

export const DRUID_TALENTS: TalentMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Resto Druid
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [TALENT_ID.DRUID.RESTO.INNER_PEACE]: {
        id: TALENT_ID.DRUID.RESTO.INNER_PEACE,
        specId: SPEC_ID.DRUID.RESTO,

        name: "Inner Peace",
        shortName: "IP",

        game_id: 197073,
        icon_name: "ability_druid_dreamstate",
    },

    [TALENT_ID.DRUID.RESTO.TREE]: {
        id: TALENT_ID.DRUID.RESTO.TREE,
        specId: SPEC_ID.DRUID.RESTO,

        name: "Incarnation: Tree of Life",
        shortName: "Tree",

        game_id: 33891,
        icon_name: "ability_druid_improvedtreeform",
    },

}
